import { operatorApiFetch } from './apiService';

export const shelfService = {
  // 列表 (分頁/表格)
  getRecords: async (params) => {
    const response = await operatorApiFetch('shelves/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 取得所有 (無分頁)
  listAll: async (params = {}) => {
    const response = await operatorApiFetch('shelves/list_all', {
      method: 'GET',
      params
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('shelves/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 預覽批量創建（檢查重複）
  previewBatchCreate: async (data) => {
    const response = await operatorApiFetch('shelves/preview_batch_create', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // 批量創建
  batchCreate: async (data) => {
    const response = await operatorApiFetch('shelves/batch_create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // 更新預設模板
  updateDefaultTemplate: async (template) => {
    const response = await operatorApiFetch('shelves/update_default_template.json', {
      method: 'PATCH',
      body: { template },
    });
    return response.json();
  },

  // 更新貨架
  update: async (id, data) => {
    const res = await operatorApiFetch(`shelves/${id}`, {
      method: 'PUT',
      body: { shelf: data }
    });
    return res.json();
  },

  // 獲取貨架庫存
  getInventories: async (params) => {
    const response = await operatorApiFetch('inventory_shelves/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 全選 ID (庫存)
  getInventoryIds: async (params) => {
    const response = await operatorApiFetch('inventory_shelves/get_ids', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 批次產生儲位條碼 PDF
  generateBarcodes: async (params) => {
    const response = await operatorApiFetch('shelves/generate_barcodes', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 批次刪除儲位（透過 worker；有任何 FK 引用會自動 skip）
  batchDelete: async (shelfIds) => {
    const response = await operatorApiFetch('shelves/batch_delete', {
      method: 'POST',
      body: JSON.stringify({ shelf_ids: shelfIds }),
    });
    return response.json();
  },

  // 搜尋貨架（autocomplete 用）
  // GET /api/operator/v1/shelves?search=<prefix>&shelves.warehouse_id=<id>&shelves.role=storage&page_size=10
  search: async ({ locationPrefix, warehouseId, role = 'storage', limit = 10 } = {}) => {
    const qs = new URLSearchParams();
    if (locationPrefix) qs.set('search', locationPrefix);
    if (warehouseId) qs.set('shelves.warehouse_id', warehouseId);
    if (role) qs.set('shelves.role', role);
    qs.set('page_size', String(limit));

    const res = await operatorApiFetch(`shelves?${qs.toString()}`);
    const body = await res.json();
    return (body?.data || []).map(s => ({ id: s.id, location: s.location, role: s.role }));
  },
};
export default shelfService;